let config = {
  defaultPath: "",
  basename: "/",
  LOGIN_PATH: "/login",
  APP_NAME: "olifield",
  BLANK_LINK: "#!",
};

export default config;
